export default "__VITE_ASSET__923116b1__"